import React from 'react';
import {Outlet, useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import useScrollToTop from '../hooks/useScrollToTop';
import LazyLoad from 'react-lazyload';
import '../../assets/styles/languages/languagefontfamily.css';
import classnames from 'classnames';
import Footer4ConsumerAsync from './footer4consumer/async';
import FadeTransition from '../transition/fade';
import webUtils from '../../utils/webUtils';
import _get from 'lodash/get';

export default ({backgroundImage, breadcrumb = []}) => {
  useScrollToTop();
  const {i18n} = useTranslation();
  const params = useParams();

  return (
    <FadeTransition>
      <div
        className={classnames({
          'pf-language': true,
          'pf-language-ja': i18n.language === 'ja',
        })}
        style={{
          background:
            backgroundImage &&
            `url(${webUtils.normalizeImageUrl(backgroundImage)}) no-repeat 50% fixed`,
          backgroundSize: 'cover',
        }}
      >
        <div
          style={{
            minHeight: '100vh',
            overflowX: 'hidden',
            overflowY: 'hidden',
          }}
        >
          {/* force page remount when appType changes */}
          <Outlet
            key={_get(params, 'appType', '')}
            context={{breadcrumb}}
          />
        </div>
        {!webUtils.isMobile() ? (
          <Footer4ConsumerAsync pageReady={true} />
        ) : (
          <LazyLoad
            height={500}
            once={true}
            unmountIfInvisible={true}
            throttle={100}
          >
            <Footer4ConsumerAsync pageReady={true} />
          </LazyLoad>
        )}
      </div>
    </FadeTransition>
  );
};
